<app-header-tela [titulo]="'Agendar pedido'" [exibirFechar]="true" (fechou)="cancelar()"></app-header-tela>

<div class="agendar-produto">
  <div class="aviso">
    <i class="fas fa-calendar-alt"></i>
    <div>
      <b>{{produto.nome}}</b> está disponível <b>{{produto.descricaoDisponibilidade}}</b>.
      Escolha como quer receber e quando. A data vale para o pedido inteiro.
    </div>
  </div>

  <p class="mensagem" *ngIf="mensagem">
    <i class="fas fa-exclamation-triangle mr-1"></i>{{mensagem}}
  </p>

  <form #frmAgendarProduto="ngForm" novalidate>
    <label class="titulo">Como você quer receber?</label>
    <div class="formas">
      <label class="forma" *ngFor="let forma of formasDeEntrega"
             [class.selecionada]="rascunho.entrega.formaDeEntrega === forma.nome">
        <input type="radio" name="formaDeEntregaAgendada" [value]="forma.nome"
               [(ngModel)]="rascunho.entrega.formaDeEntrega" (ngModelChange)="alterouForma()">
        <span>{{forma.nome}}</span>
      </label>
    </div>

    <p class="text-muted font-12" *ngIf="!formasDeEntrega.length">
      Nenhuma forma de entrega aceita agendamento no momento.
    </p>

    <div class="agendamento" *ngIf="exibirAgendamento && rascunho.entrega.formaDeEntrega">
      <app-agendar-entrega [empresa]="empresa" [pedido]="rascunho" [formasDeEntrega]="formasDeEntrega"
                           [agendarEntrega]="true" [apenasAgendamento]="true" [tela]="this"></app-agendar-entrega>
    </div>
  </form>

  <div class="acoes">
    <button type="button" class="btn btn-light" (click)="cancelar()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="!podeConfirmar()" (click)="confirmar()">
      Confirmar agendamento
    </button>
  </div>
</div>
